class TransactionDetailsStaticUtils {
  getDateFilterFields() {
    const date = [
      {
        date: '1 week',
      },
      {
        date: '2 weeks',
      },
      {
        date: '1 month',
      },
      {
        date: '3 months',
      },
      {
        date: '6 months',
      },
      {
        date: 'Custom Date',
      },
    ];
    return date;
  }

  getTypeFilterFields() {
    const type = [
      {
        tabName: 'All',
        eventKey: 'all',
      },
      {
        tabName: 'Money In',
        eventKey: 'moneyin',
      },
      {
        tabName: 'Money Out',
        eventKey: 'moneyout',
      },
      {
        tabName: 'Repeating',
        eventKey: 'repeating',
      },
    ];
    return type;
  }

  getColumnMetaData() {
    const columnData = [
      {
        columnName: 'logo',
        order: 0,
        locked: false,
        visible: true,
        displayName: 'Logo',
        hideColumnName: true,
        sortable: false,
        cssClassName: 'transaction__logo__column',
      },
      {
        columnName: 'id',
        order: 1,
        locked: false,
        visible: false,
        displayName: 'id',
      },
      {
        columnName: 'date',
        order: 2,
        locked: false,
        visible: true,
        displayName: 'date',
        sortable: true,
        sortDirectionCycle: ['desc', 'asc'],
        cssClassName: 'transaction__date__column',
      },
      {
        columnName: 'account',
        order: 3,
        locked: false,
        visible: true,
        displayName: 'Account',
        sortable: true,
        sortDirectionCycle: ['desc', 'asc'],
        cssClassName: 'transaction__description__column',
      },
      {
        columnName: 'description',
        order: 4,
        locked: false,
        visible: false,
        displayName: 'description',
        sortable: true,
        cssClassName: 'transaction__description__column',
      },
      {
        columnName: 'type',
        order: 5,
        locked: false,
        visible: false,
        displayName: 'type',
        sortable: true,
        cssClassName: 'transaction__type__column',
      },
      {
        columnName: 'tag',
        order: 6,
        locked: false,
        visible: false,
        displayName: 'tag',
        sortable: false,
        cssClassName: 'transaction__tag__column',
      },
      {
        columnName: 'debit',
        order: 8,
        locked: false,
        visible: false,
        displayName: 'debit',
        sortable: true,
        cssClassName: 'transaction__debit__column',
      },
      {
        columnName: 'credit',
        order: 9,
        locked: false,
        visible: false,
        displayName: 'credit',
        sortable: true,
        cssClassName: 'transaction__credit__column',
      },
      {
        columnName: 'amount',
        order: 10,
        locked: false,
        visible: false,
        displayName: 'amount',
        sortable: true,
        cssClassName: 'transaction__amount__column',
      },
      {
        columnName: 'balance',
        order: 10,
        locked: false,
        visible: false,
        displayName: 'balance',
        sortable: false,
        multiOff: true,
        cssClassName: 'transaction__balance__column',
      },
      {
        columnName: 'more',
        order: 10,
        locked: false,
        visible: true,
        displayName: 'more',
        sortable: false,
        cssClassName: 'transaction__more__column',
      },
    ];
    return columnData;
  }

  getColumnListData() {
    const columnsList = [
      'logo',
      'date',
      'description',
      'type',
      'tag',
      'amount',
      'balance',
      'more',
    ];
    return columnsList;
  }

  getColumnListDataForSME() {
    const columnsList = [
      'date',
      'description',
      'type',
      'debit',
      'credit',
      'balance',
      'more',
    ];
    return columnsList;
  }

  getColumnListDataForSMEAccountPools() {
    const columnsList = [
      'date',
      'description',
      'type',
      'debit',
      'credit',
      'balance',
    ];
    return columnsList;
  }
}

export default new TransactionDetailsStaticUtils();
